export enum FloorTypeEnum {
  External = 1,
  Roof,
  Basement,
  Mezzanine,
  Loft,
  Number,
  Ground_Floor,
}
